import React from "react"
import tw, { styled, css } from "twin.macro"

import { SlideProps } from "."

interface Props {
  // Is the enrol button hidden?
  hideEnrolButton?: boolean
  // Event handler when the button is clicked
  enrolButtonClicked?: () => void
}
import SlideSection from "../components/slideSectionWBG"
import EnrolForm from "../components/enrolForm"

const EnrolSlide: React.SFC<Props> = () => {
  return (
    <SlideSection>
      <div css={[tw`flex flex-col items-center`]}>
              <div
                  id="form-wrapper"
          css={[
            css`
              width: 25.75rem;
              height: 100vh;
              overflow-y: auto;
              padding: 750px 0 200px;
              ::-webkit-scrollbar {
                -webkit-appearance: none;
                width: 7px;
              }
              @media (max-width: 768px) {
                padding: 50px 0px 0px;
                overflow-y: scroll;
                justify-content: inherit;
                -webkit-overflow-scrolling: touch;
                ::-webkit-scrollbar {
                  -webkit-appearance: none;
                  width: 7px;
                }
                
                ::-webkit-scrollbar-thumb {
                  -webkit-appearance: none;
                  border-radius: 4px;
                  box-shadow: 0 0 1px rgba(255, 255, 255, .5);
                }
              }
            `,
            tw`flex flex-col items-center justify-center`,
          ]}
        >
          <div css={[css`font-family: interstate; line-height: 55.8px; font-weight: 700; 
              @media (max-width: 768px) {
                font-size: 40px;
                line-height: 42px;
                width: 76vw;
                margin-top: 0rem;
              }`, tw`text-6xl text-center mb-10 mt-16`]}>
            <tspan>
              Enrol now for free
            </tspan>
          </div>

          <EnrolForm />
        {/* <div css={[
          css`margin-top: 5vh;`,
          tw`flex justify-center`]}>
          <p
            css={[
              css`@media (max-width: 768px) {
                margin-bottom: 15rem;
                width: 80vw;
              }`,
              tw` text-center text-sm my-4 px-4`,
              css`
                max-width: 37rem;
                
              `,
            ]}
          >
            There's never been a better time to consider a career in the automotive industry. 
            Load up your CV and get trucking with our NZQA recognised MITO Micro - 
            Free until 31 March 202? (date to confirm)
          </p>
        </div> */}
        </div>
      </div>
      <div css={[tw`absolute bottom-0 w-full`]}>
      </div>
    </SlideSection>
  )
}

export default EnrolSlide
